<template>
  <div class="message">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="search" placeholder="请输入标题" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-button type="primary" @click="goadd(1)">发布消息</el-button>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="title" label="标题"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="con" label="内容"></el-table-column>
          <!-- <el-table-column min-width="100" show-overflow-tooltip prop="sortNum" label="排序"></el-table-column> -->
          <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="发布时间"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="160">
            <template slot-scope="scope">
              <el-button class="btn" type="" size="" plain @click="goadd(2, scope.row)">修改</el-button>
              <el-button class="btn" type="danger" size="" plain @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.noticeInfoselect, {
          params: {
            title: this.search,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          let list = res.result.list
          this.tableData = list.map(e => {
            return {
              ...e,
              con: this.convertToPlainText(e.content),
            }
          })
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    convertToPlainText(richText) {
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = richText
      const imgElements = tempDiv.getElementsByTagName("img")
      for (let i = 0; i < imgElements.length; i++) {
        const img = imgElements[i]
        const imgPlaceholder = document.createElement("span")
        imgPlaceholder.textContent = "【图片】"
        img.parentNode.replaceChild(imgPlaceholder, img)
      }
      tempDiv.remove()
      return tempDiv.textContent
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    goadd(val, e) {
      this.$router.push({ name: "contentsMessageDetail", query: { add: val, id: e?.id } })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("即将删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(`${this.$api.noticeInfodelete}/${row.id}`)
            .then(res => {
              this.$message.success(res.desc)
              this.getList()
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss"></style>
